"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFeatureIntegration = exports.OpenFeatureIntegrationHook = void 0;

var _core = require("@sentry/core");

var _featureFlags = require("../../../utils/featureFlags.js");

const openFeatureIntegration = exports.openFeatureIntegration = (0, _core.defineIntegration)(() => {
  return {
    name: 'OpenFeature',

    processEvent(event, _hint, _client) {
      return (0, _featureFlags.copyFlagsFromScopeToEvent)(event);
    }

  };
});
/**
 * OpenFeature Hook class implementation.
 */

class OpenFeatureIntegrationHook {
  /**
   * Successful evaluation result.
   */
  after(_hookContext, evaluationDetails) {
    (0, _featureFlags.insertFlagToScope)(evaluationDetails.flagKey, evaluationDetails.value);
  }
  /**
   * On error evaluation result.
   */


  error(hookContext, _error, _hookHints) {
    (0, _featureFlags.insertFlagToScope)(hookContext.flagKey, hookContext.defaultValue);
  }

}

exports.OpenFeatureIntegrationHook = OpenFeatureIntegrationHook;